import type { NavigateOptions, To } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { StoreNameEnum } from "../../enum/storesEnum";
import { decryptRoute, encryptRoute } from "../../utils/encryption";

export interface CustomNavigateFunction {
	(to: To, options?: NavigateOptions): void;
	(delta: number): void;
}
const ROUTE_SYSTEM_UNAVAILABLE = "/system-unavailable";

export const useNavigateCustom = (): CustomNavigateFunction => {
	const navigate = useNavigate();

	// mantém histórico da ultima rota acessada na sessionStorage, mas nao armazena a rota de sistema indisponível
	const saveLastRoute = (to: To): void => {
		if (typeof to === "string" && to !== ROUTE_SYSTEM_UNAVAILABLE) {
			sessionStorage.setItem(StoreNameEnum.LAST_ROUTE, encryptRoute(to));
		}
	};

	const customNavigate = ((to: To | number, options?: NavigateOptions) => {
		const lastRouteEncrypted = sessionStorage.getItem(StoreNameEnum.LAST_ROUTE);
		const lastRoute = lastRouteEncrypted ? decryptRoute(lastRouteEncrypted) : "/";

		if (typeof to === "number") {
			navigate(to);
		} else {
			saveLastRoute(to);

			navigate(to, {
				...options,
				state: {
					...options?.state,
					isInternalNavigation: true,
					routeTryAgain: lastRoute,
				},
			});
		}
	}) as CustomNavigateFunction;

	return customNavigate;
};
